import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import Heading from "@vfuk/core-heading";
import Spacing from "@vfuk/core-spacing/";

import { FloatingLabelInput } from "../FloatingLabelInput";
import { ValidationCheckIcon } from "../ValidationCheckIcon";
import {
  hasLettersNumbersSymbols,
  hasPasswordLength,
  hasUpperAndLowerCase,
} from "../utils";

interface ChangeMyPasswordFormProps {
  password: string;
  onPassword: Dispatch<SetStateAction<string>>;
  newPassword: string;
  onNewPassword: Dispatch<SetStateAction<string>>;
  confirmNewPassword: string;
  onConfirmNewPassword: Dispatch<SetStateAction<string>>;
}

const ProfileChangePasswordForm = ({
  password,
  onPassword,
  newPassword,
  onNewPassword,
  confirmNewPassword,
  onConfirmNewPassword,
}: ChangeMyPasswordFormProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <Heading size={3}>{t("core:auth:title_change_password")}</Heading>

      <Spacing spacingLevel={{ top: 4, bottom: 4 }}>
        <FloatingLabelInput
          label={t("core:auth:old_password")}
          type="password"
          placeholder=""
          value={password}
          id="password"
          onChange={(e) => {
            onPassword(e.target.value);
          }}
        />
      </Spacing>

      <Spacing spacingLevel={{ top: 4, bottom: 4 }}>
        <FloatingLabelInput
          label={t("core:auth:password")}
          type="password"
          value={newPassword}
          id="newPassword"
          onChange={(e) => onNewPassword(e.target.value)}
        />
      </Spacing>

      <FloatingLabelInput
        label={t("core:auth:confirm_password")}
        type="password"
        value={confirmNewPassword}
        id="confirmPassword"
        onChange={(e) => onConfirmNewPassword(e.target.value)}
      />

      <Spacing spacingLevel={{ top: 6 }}>
        <ValidationCheckIcon
          text={t("core:auth:validation_characters")}
          isValid={hasPasswordLength(newPassword, confirmNewPassword)}
        />
        <ValidationCheckIcon
          text={t("core:auth:validation_symbols")}
          isValid={hasLettersNumbersSymbols(newPassword, confirmNewPassword)}
        />
        <ValidationCheckIcon
          text={t("core:auth:validation_case")}
          isValid={hasUpperAndLowerCase(newPassword, confirmNewPassword)}
        />
      </Spacing>
    </div>
  );
};

export default ProfileChangePasswordForm;
